import * as React from 'react';

import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { Overlay } from '../components/Overlay';
import { Projects } from './Projects';
import { Videos } from './Videos';
import { useMobileLayout } from 'hooks/useMobileLayout';
import { TabBarView } from 'components/TabBarView';

export const Library: React.FC = () => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const onClose = React.useCallback(() => {
    storeDispatch(Actions.goBack());
  }, []);

  const isMobile = useMobileLayout();

  React.useEffect(() => {
    storeDispatch({ type: Actions.OPEN_PAGE });
    return () => {
      storeDispatch({ type: Actions.CLOSE_PAGE });
    };
  }, []);

  return (
    <Overlay onClose={onClose} title="Library" fullWidth={true} alignTop={true}>
      <TabBarView
        items={['Projects', 'Videos']}
        selectedIndex={tabIndex}
        onChange={setTabIndex}
        style={{ width: isMobile ? '100%' : '400px', marginBottom: 16 }}
      />
      {tabIndex === 0 ? <Projects /> : <Videos />}
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/library/index.tsx